/**
 * Satu definisi "produk ini dilacak per pcs (barcode unik) atau per qty".
 *
 * Sebelumnya pemeriksaan `!== false` ditulis ulang di lima tempat — daftar produk,
 * modal pilih produk, halaman detail, form update, dan laporan stok. Nilai yang sama
 * ditafsirkan lima kali adalah cara termudah agar salah satunya menyimpang.
 *
 * KENAPA NILAI YANG TIDAK ADA DIBACA "PER PCS":
 * `m_product.is_unique_barcode` adalah BOOLEAN `allowNull: false` dengan
 * `defaultValue: true` (migration 997), jadi `undefined` TIDAK PERNAH berarti
 * "per qty" — artinya endpoint-nya tidak menyertakan kolom itu. Membaca nilai
 * yang hilang sebagai `false` justru berbahaya: form update akan menampilkan
 * "Per Qty" untuk barang yang sebenarnya per pcs, dan menyimpan tanpa menyentuh
 * field itu akan mengirim "false" — mematikan pelacakan unit sebuah produk tanpa
 * ada yang memintanya. Default kolomnya `true`, jadi asumsi yang aman juga `true`.
 *
 * KENAPA STRING DAN ANGKA TETAP DITANGANI:
 * Saat ini kolomnya BOOLEAN dan sampai ke frontend sebagai boolean asli (sudah
 * diperiksa langsung ke DB). Tapi `!== false` menganggap `0` dan `"false"` sebagai
 * TRUE, jadi kalau suatu saat ada endpoint atau dialek yang menyerahkannya sebagai
 * angka/string, barang per-qty akan tampil per-pcs dan tersimpan per-pcs secara
 * diam-diam. Normalisasi ini menutup arah itu tanpa mengubah default di atas.
 */
const FALSY = new Set([false, 0, "false", "0", "f", "no"]);

export function isUniqueBarcode(value) {
  if (value === undefined || value === null) return true;
  if (typeof value === "string") return !FALSY.has(value.trim().toLowerCase());
  return !FALSY.has(value);
}
